









































































































































































































































































import Pagination from '@/components/lookup/Pagination.vue'
import { genericErrorMessage } from '@/constants'
import { aggregateFieldService } from '@/services'
import { AggregateFieldModel } from '@/types/FormulaFieldType'
import { SearchConfigField } from '@/types/utilTypes'
import { getAxiosErrors } from '@/utils'
import Vue from 'vue'

function generateInitialState() {
    return {
        success: false,
        error: false,
        validationErrors: {} as Record<string, string>,
        loading: false
    }
}

function generateInitialFormState() {
    return {
        id: '',
        fieldLabel: '',
        aggregateField: null as SearchConfigField | null,
        aggregateFunction: '',
        type: '',
        state: generateInitialState(),
        dialog: false,
        dialogDelete: false,
    }
}

export default Vue.extend({
    components: { Pagination},
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        fields:{
            type: Array as () => SearchConfigField[]
        },
        page: {
            type: String
        }
    },
    async mounted() {
        await this.getAggregateFields()
    },
    watch: {
        async dialog(newVal: boolean) {
            if(newVal) {
                await this.getAggregateFields()
            }
        }
    },
    data() {
        return {
            loading: false,
            aggregateFunctions: [
                { text: 'Sum', value: 'SUM', types: ['number'] },
                { text: 'Average', value: 'AVG', types: ['number'] },
                { text: 'Count', value: 'COUNT', types: ['number', 'string', 'date', 'boolean'] },
                { text: 'Max', value: 'MAX', types: ['number', 'string', 'date', 'boolean'] },
                { text: 'Min', value: 'MIN', types: ['number', 'string', 'date', 'boolean'] }
            ],
            headers: [
                {text: 'Field Label' , value:'fieldLabel'},
                {text: 'Aggregate Field', value:'aggregateField'},
                {text: 'Aggregate Function', value: 'aggregateFunction'},
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            form: generateInitialFormState(),
            search: '',
            tempSearch: '',
            pagination: {
                pageIndex: 1,
                pageSize: 10,
                pages: 1,
                sizes: [
                    5,
                    10,
                    100
                ],
            },
            genericErrorMessage: genericErrorMessage
        }
    },
    methods: {
        async processAction(callbackFunc: any) {
            try {
                this.form.state = generateInitialState()
                this.form.state.loading = true
                await callbackFunc()
                this.form.state.success = true
                await this.getAggregateFields()
                await this.$store.dispatch('getCurrentPageConfig')
                this.$emit('onAggregateFieldsModification')
            } catch(e) {
                this.form.state.error = true
                this.form.state.validationErrors = getAxiosErrors(e)
            } finally {
                this.form.state.loading = false
            }
        },
        async save() {
            await this.processAction(async()=> {
                await aggregateFieldService.upsert({
                    id: this.form.id,
                    fieldLabel: this.form.fieldLabel,
                    aggregateField: this.form.aggregateField?.alias ?? '',
                    aggregateFunction: this.form.aggregateFunction,
                    page: this.page,
                    type: '',
                    lastUpdated: '',
                    lastUpdatedBy: ''
                })
            })
        },
        async deleteFieldConfirm() {
            await this.processAction(async()=>{
                await aggregateFieldService.delete(this.form.id)
                this.form.id = ''
            })
        },
        editField(aggField: AggregateFieldModel) {
            this.form.id = aggField.id
            this.form.fieldLabel = aggField.fieldLabel
            this.form.aggregateField = this.internalFields.find(field => field.alias === aggField.aggregateField) || null
            this.form.aggregateFunction = aggField.aggregateFunction
            this.form.dialog = true
        },
        deleteField(aggField: AggregateFieldModel) {
            this.form.id = aggField.id
            this.form.fieldLabel = aggField.fieldLabel
            this.form.aggregateFunction = aggField.aggregateFunction
            this.form.dialogDelete = true
        },
        onSearch() {
            this.search = this.tempSearch.trim()
        },
        onClearSearch() {
            this.search = ''
            this.tempSearch = ''
        },
        onSearchOptionChange(options: { pageIndex?: number, pageSize?: number }) {
            if (options.pageIndex !== undefined) {
                this.pagination.pageIndex = options.pageIndex
            }

            if (options.pageSize !== undefined) {
                this.pagination.pageSize = options.pageSize
            }
        },
        clearForm() {
            this.form = generateInitialFormState()
        },
        async getAggregateFields() {
            this.loading = true
            await this.$store.dispatch('getAggregateFields', this.page)
            this.loading = false
        }
    },
    computed: {
        allowedAggregateFunctions() : any {
            const aggFieldType = this.form.aggregateField?.type || ''
            return this.aggregateFunctions.filter( (aggregateFunc: any) => aggregateFunc.types.includes(aggFieldType))
        },
        internalFields(): SearchConfigField[] {
            return this.fields.filter(field => !field.isExternalField)
        },
        isActionFinal(): boolean{ 
            return this.form.state.success && !this.form.id
        },
        closeText(): string {
            return this.isActionFinal ? 'Close': 'Cancel'
        }
    }
})
